export const profileFields = [
  {
    name: 'revendedor-allied',
    fields: [
      'cpfCnpj',
      'razaoSocial',
      'nomeFantasia',
      'inscricaoEstadual',
      'email',
      'telefone',
      'endereco',
      'dadosBancarios',
      'vendedorAdicional',
      'vendedor',
    ],
  },
  {
    name: 'comprador-revenda',
    fields: [
      'razaoSocial',
      'nomeFantasia',
      'inscricaoEstadual',
      'telefone',
      'endereco',
      'cpfCnpj',
      'razaoSocial',
      'email',
    ],
  },
  {
    name: 'vendedor-revenda',
    fields: [
      'razaoSocial',
      'nomeFantasia',
      'inscricaoEstadual',
      'telefone',
      'endereco',
      'dadosBancarios',
      'cpfCnpj',
      'razaoSocial',
      'email',
    ],
  },
  {
    name: 'colaborador-allied',
    fields: ['email'],
  },
  {
    name: 'vendedor-allied',
    fields: ['email', 'cpfCnpj', 'vendedor', 'vendedorAdicional'],
  },
  {
    name: 'cliente-final',
    fields: [
      'email',
      'cpfCnpj',
      'nome',
      'canaisResponsaveis',
      'inscricaoEstadual',
      'grupoEconomico',
    ],
  },
  {
    name: 'administrador',
    fields: ['email'],
  },
];
